import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pf-email-input-field',
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, TranslocoModule],
  templateUrl: './email-input-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './email-input-field.component.scss',
})
export class EmailInputFieldComponent {
  sizeMap = new Map<string, string>([
    ['large', 'w-6 h-6'],
    ['medium', 'w-5 h-5'],
    ['small', 'w-4 h-4'],
  ])

  //Set options here when adding a new attribute
  @Input() label = '';
  @Input() placeholder = '';
  @Input() icon = '';
  @Input() value = '';
  @Input() iconColor = 'fill-black';
  @Input() iconSize: 'large' | 'medium' | 'small' = 'large';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() inputFormControl: FormControl | null = null;

  @Output() onChange = new EventEmitter();
  emailFormControl = new FormControl(this.value, [Validators.required, Validators.email]);
  inputInlineStart = 'ps-3.5';
  iconInlineStart = 'start-0 ps-3.5'

  public ngOnInit() {
    if (this.icon != '' && this.iconPosition == 'left') {
      switch (this.iconSize) {
        case 'large': this.inputInlineStart = 'ps-11'; break;
        case 'medium': this.inputInlineStart = 'ps-10'; break;
        case 'small': this.inputInlineStart = 'ps-9'; break;
      }
    } else if (this.icon != '' && this.iconPosition == 'right') {
      this.iconInlineStart = 'end-0 pe-3.5'
    }

    this.emailFormControl.setValue(this.value)
    if (this.inputFormControl) {
      this.emailFormControl = this.inputFormControl;
    }
    this.emailFormControl.valueChanges.subscribe(change => {
      this.onChange.emit(this.emailFormControl);
    });
  }
}